import { lazy, Suspense, useRef, useState } from "react";
import { Link, useTitle } from "easy-page-router/react";
import { Header, Loading } from "../components";
import { useHeaders, useSSRHook } from "../../ssrh/client";
import { handleContentFiles } from "../services/editor";
import { api } from "../services/api";
import { useUser } from "../User";
import Footer from "../components/Footer";

import { Page, PageMeta } from "../../types";

const Editor = lazy(() => import("../components/Editor"));

export default function Contact() {
    const { isAdmin } = useUser();

    const [page, error, isLoading, reload] = useSSRHook<Page & PageMeta>("/api/page?url=kontakty");

    const title = "Kontakt | TSO Krkonoše";
    const description = "Kontakty na technický svazek obcí Krkonoše";

    useTitle(title);
    useHeaders({
        title,
        description,
        image: window.location.origin + "/logo.png",
        canonical: window.location.origin + window.location.pathname,
    });

    const [edit, setEdit] = useState<null | Page>(null);
    const [message, setMessage] = useState("");

    const refEditor = useRef<HTMLDivElement>(null);

    async function handleSave() {
        if (!edit) return;
        if (!refEditor.current) {
            setMessage("Problém s editorem");
            return;
        }

        const { content, files } = await handleContentFiles(edit, refEditor.current);

        const [respond] = await api.updatePage({
            _id: edit._id,
            title: edit.title,
            content,
            files,
        });

        if (!respond) {
            setMessage("Ukládání změn selhalo");
            return;
        }

        reload();
        setMessage("Kontakty úspěšně uloženy");
        setEdit(null);
    }

    return <>
        <main>
            <Header background="mountain" title="Kontakty">
                <Link to="/o-nas">O nás</Link>
                <span className="space">-</span>
                Kontakty
            </Header>
            <div className="content">
                <section>
                    <div className="page">
                        <h1 className="hidden">Kontakty</h1>
                        <div className="contact-frame">
                            <div className="left">
                                <div className="img1" />
                                <div className="img2" />
                                <div className="contacts">
                                    <ul>
                                        <li>
                                            <h3>Telefon</h3>
                                            <div className="icon phone" />
                                            <span>
                                                Volejte na <br />
                                                <a href="tel:+420605759389">+420 605 759 389</a>
                                            </span>
                                        </li>
                                        <li>
                                            <h3>Emailová adresa</h3>
                                            <div className="icon mail" />
                                            <span>
                                                Pište na <br />
                                                <a href="mailto:paulu@tsokrkonose.cz">paulu@tsokrkonose.cz</a>
                                            </span>
                                        </li>
                                        <li>
                                            <h3>Naše kancelář</h3>
                                            <div className="icon map" />
                                            <span>
                                                Roztocká 500 <br />
                                                514 01 Jilemnice
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="right">
                                {isAdmin && <div className="admin">
                                    {!edit && <button onClick={() => setEdit(page)}>Upravit obsah</button>}
                                    {edit && <button onClick={handleSave}>Uložit změny</button>}
                                </div>}
                                <section>
                                    <div className="content">
                                        <h1 className="hidden">Kontakty</h1>
                                        {message && <p className="alert">{message}</p>}
                                        {isLoading && <Loading />}

                                        {!edit && page && <div
                                            className="html-content ck-content"
                                            dangerouslySetInnerHTML={{ __html: page.content }}
                                        />}
                                        {edit && <div ref={refEditor}>
                                            <Suspense fallback={<Loading />}>
                                                <Editor
                                                    value={edit.content}
                                                    onChange={(value) => setEdit({ ...edit, content: value })}
                                                />
                                            </Suspense>
                                        </div>}
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <section>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2532.1994955938094!2d15.50751209775016!3d50.60483046071573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470ebf0189e30677%3A0xf02dc41a828f4711!2sRoztock%C3%A1%20500%2C%20514%2001%20Jilemnice!5e0!3m2!1scs!2scz!4v1731601233373!5m2!1scs!2scz" width="100%" height="500" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </section>
        </main>
        <Footer />
    </>;
}
